document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".sansu-feature-card");

  if (!cards.length) return;

  const observer = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      if (!entry.isIntersecting) return;

      entry.target.classList.add("is-visible");

      observer.unobserve(entry.target);

    });

  }, {
    threshold: 0.15
  });

  cards.forEach((card) => {

    const link = card.querySelector(".sansu-feature-btn");

    if (link && link.getAttribute("href")) {
      card.style.cursor = "pointer";

      card.addEventListener("click", (e) => {
        if (e.target.closest("a")) return;
        window.location.href = link.href;
      });
    }

    observer.observe(card);

  });

});